import configureStore from './configureStore';
import { getReduxStateFromStorage, deleteReduxStateFromStorage } from '../assets/helpers/utils';

const initalState = getReduxStateFromStorage();
const store = configureStore(initalState);
deleteReduxStateFromStorage();

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js